import { SecondMeetingSecondStepComponent } from './../form-steps/second-meeting-second-step/second-meeting-second-step.component';
import { NextOrSkipMeetingsComponent } from './../form-steps/next-or-skip-meetings/next-or-skip-meetings.component';
import { SecondMeetingFirstStepComponent } from './../form-steps/second-meeting-first-step/second-meeting-first-step.component';
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormSummary } from "../form-steps/form-summary/form-summary";

const routes = [

    {
      path: '',
      redirectTo: 'first',
      pathMatch: 'full'
    },
  
    {
        path: 'first',
        component: SecondMeetingFirstStepComponent,
        /*children: [{
          path: '',
          loadChildren:
            () => import('./form/meeting-form/meeting-form.module')
            .then(m => m.MeetingFormModule),
          outlet: 'formstep'
        }]*/
    },
    {
        path: 'second',
        component: SecondMeetingSecondStepComponent
    },
    {
        path: 'third',
        component: NextOrSkipMeetingsComponent
    },
    {
        path: 'summary',
        component: FormSummary,
        data: {form: 'composer'}
    }
    
  ]
  
  @NgModule({
    imports: [
      RouterModule.forChild(routes),
    ],
    exports: [
      RouterModule
    ]
  })
  export class SecondMeetingRoutingModule {
  
  }